// extracted by mini-css-extract-plugin
module.exports = {"date-range-input":"daterange_date-range-input__2tI4K","selected-range":"daterange_selected-range__kJht-","selected-range-text":"daterange_selected-range-text__2GkVp"};